import React, { FunctionComponent } from 'react';
import { generatePath, Navigate, useParams } from 'react-router-dom';

interface IProps {
    to: string;
    replace?: boolean;
    state?: any;
}

const RedirectRoute: FunctionComponent<IProps> = ({ to, replace, state }) => {
    const params = useParams();
    const redirectWithParams = generatePath(to, params);

    return <Navigate to={redirectWithParams} replace={replace} state={state} />;
};

export default RedirectRoute;
